import axios from '../axios';

export default {
  getRegions () {
    return new Promise((resolve, reject) => {
      axios.get('/region')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getRegion (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/region/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getRegionSkudEquipment (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/region/${id}/skud-equipment`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
